let baseStyle = {
    container: (provided) => ({
        ...provided,
        height: '45px',
        backgroundColor: '#6e161a',
        borderTopRightRadius: '5px'
    }),
    placeholder: (provided) => ({
        ...provided,
        color: 'white',
        padding: '0 0 0 5px'
    }),
    input: (provided) => ({
        ...provided,
        margin: 0,
        padding: 0
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: '0',
        lineHeight: '45px',
        height: '45px',
        flexWrap: 'nowrap'
    }),
    menu: (provided) => ({
        ...provided,
        margin: 0
    }),
    menuList: (provided) => ({
        ...provided,
        background: '#6e161a'
    }),
    option: (provided, state) => ({
        ...provided,
        height: '45px',
        lineHeight: '45px',
        backgroundColor: state.isSelected ? '#b81d23' : state.isFocused ? '#8a1a1e' : '#6e161a',
        color: 'white',
        borderBottom: 'none',
        padding: '0 5px',
        whiteSpace: 'nowrap',
        textAlign: 'left',
        ':active': {
            backgroundColor: '#b81d23',
        },
    }),
    control: () => ({
    }),
    singleValue: (provided) => ({
        ...provided,
        color: 'white',
        padding: '0 0 0 5px'
    }),
    multiValue: (provided) => ({
        ...provided,
        lineHeight: '34px',
        backgroundColor: '#8a1a1e',
        minWidth: '35px'
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: 'white'
    }),
    multiValueRemove: (provided, state) => ({
        ...provided,
        ':hover': {
            backgroundColor: '#b81d23',
            color: 'white'
        },
        color: 'white'
    })
}; 

let movieStyle = {...baseStyle};
movieStyle.menu = (provided) => ({
    ...provided,
    margin: 0,
    width: 'auto',
    right: 0
});

const CustomStyles = {
    chars: baseStyle,
    movies: movieStyle
};

export default CustomStyles;